import router from '../router'
import axios from 'axios'
import {apiUrl} from '../../env'

const API_URL = apiUrl

const routes = {
  login: API_URL + 'user/login'
}


// redirect to login if user is unauthorized
axios.interceptors.response.use(null, function (error) {
  if (error.response.status === 401) {
    localStorage.clear()
    router.go('/auth/login')
  }

  return Promise.reject(error)
})

export default {
  API_URL: API_URL,

  user: {
    authenticated: false,
    token: false
  },

  login(context, creds) {

    axios.post(routes.login, creds)
      .then((response) => {

        let res = response.data.data

        if (!res.user.isAdmin) return Vue.$snotify.error('User is not admin')

        let token = res.token
        localStorage.setItem('token', token)
        localStorage.setItem('user_id', res.user.id)

        this.user.authenticated = true
        this.user.token = token
        this.user.id = res.user.id

        router.push({path: '/dashboard'})
      }).catch((err) => {

      Vue.$snotify.error(err.response.data.message)
    })
  },

  logout() {
    localStorage.removeItem('token')
    this.user.authenticated = false
  },

  checkAuth() {
    let jwt = localStorage.getItem('token')
    let id = localStorage.getItem('user_id')

    if (jwt) {
      this.user.authenticated = true
      this.user.token = jwt
      this.user.id = id
    } else {
      this.user.authenticated = false
    }
  },

  getAuthHeader() {
    return {
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    }
  },


  get(path) {
    return axios.get(API_URL + path, {headers: this.getAuthHeader()})
  },

  post(path, params) {
    return axios.post(API_URL + path, params, {headers: this.getAuthHeader()})
  }

}



// WEBPACK FOOTER //
// ./src/services/api.js